import { useQuery } from "@tanstack/react-query";
import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getSubAccounts } from "src/api/subAccount";
import CustomDataTable from "src/components/CustomDataTable";
import CustomDropdown from "src/components/CustomDropdown";
import CustomSheet from "src/components/CustomSheet";
import AddSubAccountWithParent from "src/components/modals/AddSubAccountWithParent";
import { Button } from "src/components/ui/button";
import SearchInput from "src/components/widgets/SearchInput";
import { cn, getCustomizationValue } from "src/lib/utils";
import { useAuth } from "src/providers/AuthProvider";
import { EllipsisIcon } from "src/svg";

const columns = (user, navigate) => [
	{ name: "S/N", selector: (_, index) => index + 1, width: "80px" },
	{ name: "First Name", selector: (row) => row.firstname },
	{ name: "Last Name", selector: (row) => row.lastname },
	{ name: "ID Number", selector: (row) => row.idNo ?? "-", grow: 1.25 },
	{
		name: "Actions",
		cell: (row) => (
			<CustomDropdown
				trigger={
					<Button variant="hover">
						<EllipsisIcon />
					</Button>
				}
				actions={[
					{
						label: cn("View ", getCustomizationValue(user, "customer_label", true)),
						onClick: () => navigate(`/customers/${row.uuid}`),
					},
				].filter(Boolean)}
			/>
		),
		grow: 0.5,
	},
];

const SubAccounts = () => {
	const { user } = useAuth();
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const search = searchParams.get("search");
	const page = searchParams.get("page") || 1;
	const limit = searchParams.get("limit") || 10;

	const { data, isLoading } = useQuery({
		queryKey: ["subAccounts", page, limit, search],
		queryFn: () => getSubAccounts({ businessUuid: user?.business_uuid, page, limit, search }),
	});

	const subAccounts = data?.data?.data ?? [];
	const totalRow = data?.data?.total;

	return (
		<>
			<div className="pageTop flex-cont flex-space-between flex-align-center">
				<h2>{getCustomizationValue(user, "sub_account_label")}</h2>
			</div>
			<div className="innerContent">
				<ActionBar />

				<CustomDataTable columns={columns(user, navigate)} data={subAccounts} progressPending={isLoading} paginationTotalRows={totalRow} />
			</div>
		</>
	);
};

const ActionBar = () => {
	const { user } = useAuth();

	return (
		<div className="inner-top tw-flex-wrap tw-gap-3">
			<div className="inner-top-right tw-ml-auto tw-flex-wrap tw-gap-3">
				<SearchInput name="search" placeholder="Search..." />
				<CustomSheet
					title={cn("Add ", getCustomizationValue(user, "sub_account_label", true))}
					trigger={<button className="green-btn">Add {getCustomizationValue(user, "sub_account_label", true)}</button>}
				>
					<AddSubAccountWithParent />
				</CustomSheet>
			</div>
		</div>
	);
};

export default SubAccounts;
